import { Badge, Box } from '@mui/material';
import { useFilter } from '@dispatch/shared/hooks';
import { Filter, QuickFilterProps } from './FilterTypes';
import { ToggleButton, ToggleButtonGroup } from '../toggle-button-group';

const MAX_BADGE_COUNT = 99;

export const QuickFilters = ({
  quickFilters,
  filterKey,
  defaultValue,
}: QuickFilterProps) => {
  const filterContext = useFilter();

  const handleFilterChange = (filter?: Filter) => {
    if (!filter) {
      return;
    }
    const currentFilters = { ...filterContext.quickFilters };
    currentFilters[filterKey] = filter.value;
    filterContext.setQuickFilters(currentFilters);
  };

  const renderButtons = () => {
    return quickFilters.map((filter: Filter, index: number) => {
      if (filter?.badgeCount) {
        return (
          <Badge
            color="error"
            badgeContent={filter.badgeCount}
            max={MAX_BADGE_COUNT}
            data-testid="unassigned-tasks-button"
          >
            <ToggleButton key={index} value={filter.value}>
              {filter.label}{' '}
            </ToggleButton>
          </Badge>
        );
      }
      return (
        <ToggleButton key={index} value={filter.value}>
          {filter.label}{' '}
        </ToggleButton>
      );
    });
  };

  const getFilterByValue = (value: string) =>
    quickFilters?.find((x) => x?.value === value);

  return (
    <Box data-testid="quick-filters">
      <ToggleButtonGroup
        onClick={(filter) => handleFilterChange(getFilterByValue(filter))}
        defaultValue={defaultValue}
      >
        {renderButtons()}
      </ToggleButtonGroup>
    </Box>
  );
};
